import { createSelector } from '@reduxjs/toolkit';
import { functionsWithTaskCount } from './functions-with-task-count';

export const functionsDeletedWithTaskCount = createSelector(functionsWithTaskCount, (functions) =>
  functions.filter((c) => c.deleted),
);
